module.exports = "<sx-listado-desplegable \r\n[fuente]=\"grupos\"\r\n[tipo]=\"'CHANNEL' | i18next\">\r\n</sx-listado-desplegable>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/channel/configurar.channel.component.html
// module id = ../../../../../src/app/private/configuracion/channel/configurar.channel.component.html
// module chunks = main